import { Component, HostBinding, HostListener } from "@angular/core";
import { CalendarService } from "./../services/calendar.service";
import { DatetimeConfig } from "../classes/calendar-config";
import { SuiLocalizationService } from "../../../behaviors/localization/index";
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '../../../behaviors/localization/index';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '../views/year-view';
import * as ɵngcc4 from '../views/month-view';
import * as ɵngcc5 from '../views/date-view';
import * as ɵngcc6 from '../views/hour-view';
import * as ɵngcc7 from '../views/minute-view';

function SuiDatepicker_sui_calendar_year_view_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "sui-calendar-year-view", 2);
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("service", ctx_r0.service);
} }
function SuiDatepicker_sui_calendar_month_view_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "sui-calendar-month-view", 2);
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("service", ctx_r1.service);
} }
function SuiDatepicker_sui_calendar_date_view_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "sui-calendar-date-view", 2);
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("service", ctx_r2.service);
} }
function SuiDatepicker_sui_calendar_hour_view_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "sui-calendar-hour-view", 2);
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("service", ctx_r3.service);
} }
function SuiDatepicker_sui_calendar_minute_view_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "sui-calendar-minute-view", 2);
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("service", ctx_r4.service);
} }
export var DatepickerMode = {
    Year: "year",
    Month: "month",
    Date: "date",
    Datetime: "datetime",
    Time: "time"
};
var SuiDatepicker = /** @class */ (function () {
    function SuiDatepicker(localizationService) {
        this.service = new CalendarService(new DatetimeConfig(), localizationService.get().datepicker);
        this._calendarClasses = true;
    }
    SuiDatepicker.prototype.onMouseDown = function (e) {
        e.preventDefault();
    };
    /** @nocollapse */
    SuiDatepicker.ctorParameters = function () { return [
        { type: SuiLocalizationService, },
    ]; };
    SuiDatepicker.propDecorators = {
        "_calendarClasses": [{ type: HostBinding, args: ["class.ui",] }, { type: HostBinding, args: ["class.active",] }, { type: HostBinding, args: ["class.calendar",] },],
        "onMouseDown": [{ type: HostListener, args: ["mousedown", ["$event"],] },],
    };
SuiDatepicker.ɵfac = function SuiDatepicker_Factory(t) { return new (t || SuiDatepicker)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.SuiLocalizationService)); };
SuiDatepicker.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SuiDatepicker, selectors: [["sui-datepicker"]], hostVars: 6, hostBindings: function SuiDatepicker_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mousedown", function SuiDatepicker_mousedown_HostBindingHandler($event) { return ctx.onMouseDown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ui", ctx._calendarClasses)("active", ctx._calendarClasses)("calendar", ctx._calendarClasses);
    } }, decls: 6, vars: 6, consts: [[3, "ngSwitch"], [3, "service", 4, "ngSwitchCase"], [3, "service"]], template: function SuiDatepicker_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, SuiDatepicker_sui_calendar_year_view_1_Template, 1, 1, "sui-calendar-year-view", 1);
        ɵngcc0.ɵɵtemplate(2, SuiDatepicker_sui_calendar_month_view_2_Template, 1, 1, "sui-calendar-month-view", 1);
        ɵngcc0.ɵɵtemplate(3, SuiDatepicker_sui_calendar_date_view_3_Template, 1, 1, "sui-calendar-date-view", 1);
        ɵngcc0.ɵɵtemplate(4, SuiDatepicker_sui_calendar_hour_view_4_Template, 1, 1, "sui-calendar-hour-view", 1);
        ɵngcc0.ɵɵtemplate(5, SuiDatepicker_sui_calendar_minute_view_5_Template, 1, 1, "sui-calendar-minute-view", 1);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.service.currentView);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", 2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", 3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", 4);
    } }, directives: [ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, ɵngcc3.SuiCalendarYearView, ɵngcc4.SuiCalendarMonthView, ɵngcc5.SuiCalendarDateView, ɵngcc6.SuiCalendarHourView, ɵngcc7.SuiCalendarMinuteView], styles: ["[_nghost-%COMP%] {\n    user-select: none;\n}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuiDatepicker, [{
        type: Component,
        args: [{
                selector: "sui-datepicker",
                template: "\n<ng-container [ngSwitch]=\"service.currentView\">\n    <sui-calendar-year-view [service]=\"service\" *ngSwitchCase=\"0\"></sui-calendar-year-view>\n    <sui-calendar-month-view [service]=\"service\" *ngSwitchCase=\"1\"></sui-calendar-month-view>    \n    <sui-calendar-date-view [service]=\"service\" *ngSwitchCase=\"2\"></sui-calendar-date-view>    \n    <sui-calendar-hour-view [service]=\"service\" *ngSwitchCase=\"3\"></sui-calendar-hour-view>    \n    <sui-calendar-minute-view [service]=\"service\" *ngSwitchCase=\"4\"></sui-calendar-minute-view>    \n</ng-container>\n",
                styles: ["\n:host {\n    user-select: none;\n}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.SuiLocalizationService }]; }, { _calendarClasses: [{
            type: HostBinding,
            args: ["class.ui"]
        }, {
            type: HostBinding,
            args: ["class.active"]
        }, {
            type: HostBinding,
            args: ["class.calendar"]
        }], onMouseDown: [{
            type: HostListener,
            args: ["mousedown", ["$event"]]
        }] }); })();
    return SuiDatepicker;
}());
export { SuiDatepicker };

